/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PostCommentFormContainer_settings = {
    readonly charCount: {
        readonly enabled: boolean;
        readonly min: number | null;
        readonly max: number | null;
    };
    readonly disableCommenting: {
        readonly enabled: boolean;
        readonly message: string;
    };
    readonly closeCommenting: {
        readonly message: string;
    };
    readonly media: {
        readonly twitter: {
            readonly enabled: boolean;
        };
        readonly youtube: {
            readonly enabled: boolean;
        };
        readonly giphy: {
            readonly enabled: boolean;
        };
        readonly external: {
            readonly enabled: boolean;
        };
    };
    readonly rte: {
        readonly " $fragmentRefs": FragmentRefs<"RTEContainer_config">;
    };
    readonly " $refType": "PostCommentFormContainer_settings";
};
export type PostCommentFormContainer_settings$data = PostCommentFormContainer_settings;
export type PostCommentFormContainer_settings$key = {
    readonly " $data"?: PostCommentFormContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"PostCommentFormContainer_settings">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enabled",
        "storageKey": null
    } as any), v1 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any), v2 = [
        (v0 /*: any*/)
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "PostCommentFormContainer_settings",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "CharCount",
                "kind": "LinkedField",
                "name": "charCount",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "min",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "max",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "DisableCommenting",
                "kind": "LinkedField",
                "name": "disableCommenting",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    (v1 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "CloseCommenting",
                "kind": "LinkedField",
                "name": "closeCommenting",
                "plural": false,
                "selections": [
                    (v1 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "MediaConfiguration",
                "kind": "LinkedField",
                "name": "media",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "TwitterMediaConfiguration",
                        "kind": "LinkedField",
                        "name": "twitter",
                        "plural": false,
                        "selections": (v2 /*: any*/),
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "YouTubeMediaConfiguration",
                        "kind": "LinkedField",
                        "name": "youtube",
                        "plural": false,
                        "selections": (v2 /*: any*/),
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "GiphyMediaConfiguration",
                        "kind": "LinkedField",
                        "name": "giphy",
                        "plural": false,
                        "selections": (v2 /*: any*/),
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "ExternalMediaConfiguration",
                        "kind": "LinkedField",
                        "name": "external",
                        "plural": false,
                        "selections": (v2 /*: any*/),
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "RTEConfiguration",
                "kind": "LinkedField",
                "name": "rte",
                "plural": false,
                "selections": [
                    {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "RTEContainer_config"
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Settings",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '40309067be8944f92fe75e599126b47e';
export default node;
